<template>
    <div>
        <div class="main-container">
            <side-bar :isSplicingTable="true"/>
            <main-content class="splicing-main-content-container" :sidebarIsOpen="sidebarIsOpen">
                <SplicingTable />
            </main-content>
        </div>
  </div>
</template>
<script>
import NavBar from "@/components/Management/NavBar";
import SideBar from "@/components/Home/SideBar/SideBar";
import MainContent from "@/components/Management/Content";
import SplicingTable from "../components/Home/Forms/_SpecialTabs/Splicing/SplicingTable.vue";
export default {
    name: "Splicing",
    components: {
        NavBar,
        SideBar,
        MainContent,
        SplicingTable
    },

    data() {
        return {
            /**
             * Determines if sidebar is open
             */
            sidebarIsOpen: true
        };
    },

    methods: {
        /**
         * Toggles the value of the sidebarIsOpen variable to the opposite it has at the moment
         */
        toggleSidebar() {
            this.sidebarIsOpen = !this.sidebarIsOpen;
        }
    }
}
</script>
<style scoped>
.main-container {
  width: 100vw;
  height: 100vh;
  position: relative;
  background-color: #fafbfc;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.splicing-main-content-container{
    margin-left: 50px !important;
    margin-top: 0 !important;
    height: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/views/SplicingView.vue